/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react";

export const useIsFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const checkFullscreenStatus = () => {
      // Check for true fullscreen mode (F11 or fullscreen API)
      const isTrueFullscreen =
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement ||
        !!document.msFullscreenElement;

      // Check for windowed fullscreen (maximized window)
      const tolerance = 10; // Increased tolerance for browser UI variations
      const isWindowedFullscreen =
        window.innerWidth >= screen.availWidth - tolerance &&
        window.innerHeight >= screen.availHeight - tolerance;

      // Set fullscreen state if either condition is true
      setIsFullscreen(isTrueFullscreen || isWindowedFullscreen);
    };

    // Handle fullscreen change events for true fullscreen
    const handleFullscreenChange = () => {
      checkFullscreenStatus();
    };

    // Initial check
    checkFullscreenStatus();

    // Add event listeners
    window.addEventListener("resize", checkFullscreenStatus);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener("resize", checkFullscreenStatus);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );
    };
  }, []);

  return isFullscreen;
};
